//Library Imports
import { CSSProperties, FC, memo, ReactNode, useEffect } from "react";
import { useDrag, DragSourceMonitor } from "react-dnd";
import { useSelector } from "react-redux";
import store, { RootState } from "store";

//Local Imports
import { ItemTypes } from "../../Common/Components/ItemTypes";
import { getEmptyImage } from "react-dnd-html5-backend";
import { Box } from "../../Common/Components/Box";
import { openCurationSidebar, closeCurationSidebar } from "modules/GlobalActions";
import { startDragAction, stopDragAction } from "modules/Content/DragnDrop/actions";
import { DRAG_DROP } from "constants/actionTypes";

function getStyles(isDragging: boolean): CSSProperties {
  return {
    opacity: isDragging ? 0.5 : 1,
    width: "100%",
  };
}

export interface DraggableBoxProps {
  id?: string;
  articleId?: string;
  title?: string;
  left?: number;
  top?: number;
  blogItem?: any;
  isDraggable?: boolean;
  children?: ReactNode;
}

export const DraggableBox: FC<DraggableBoxProps> = memo(function DraggableBox(props) {
  const { curationSidebar } = useSelector((state: RootState) => state.uiReducer);

  const selectedIds: any = useSelector((state: RootState) => state.dragDrop.selectedIds);
  const { id, title, left, top, blogItem, isDraggable, children } = props;
  const [{ isDragging }, drag, preview] = useDrag(
    () => ({
      type: ItemTypes.BOX,
      item: { id, left, top, title },
      canDrag: selectedIds.length === 0 || selectedIds.includes(props.articleId),
      end: (item: unknown, monitor: DragSourceMonitor) => {
        stopDragAction();
        if (monitor.didDrop() === false) {
          setTimeout(() => {
            closeCurationSidebar();
            document.body.style.overflow = "auto";
            document.body.style.paddingRight = "0";
          }, 1);
        }
        // store.dispatch({ type: DRAG_DROP.SET_IMAGE, payload: "" });
      },
      collect: (monitor: DragSourceMonitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [isDraggable, selectedIds, id, left, top, title]
  );

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);

  const handleSidebarOpening = () => {
    startDragAction(blogItem);
    store.dispatch({
      type: DRAG_DROP.SET_NEWIMAGE,
      payload: blogItem.image_url,
    });

    setTimeout(() => {
      openCurationSidebar();
    }, 350);
  };

  if (isDragging && !curationSidebar) {
    handleSidebarOpening();
  }

  return (
    <div ref={drag} style={getStyles(isDragging)} role="DraggableBox">
      <Box blogItem={blogItem} isBeingDragged={isDragging} isDraggable={true}>
        {children ? children : null}
      </Box>
    </div>
  );
});
